export function katakanaToHiragana(katakanaString: string): string {
	return katakanaString.replace(/[\u30A1-\u30F6]/g, (match) =>
		String.fromCharCode(match.charCodeAt(0) - 0x60)
	);
}

export function hiraganaToKatakana(hiraganaString: string): string {
	return hiraganaString.replace(/[\u3041-\u3096]/g, (match) =>
		String.fromCharCode(match.charCodeAt(0) + 0x60)
	);
}
